import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import React, { useEffect, useMemo } from 'react';
import { IItemForGetShortInfo, IGetGameCategoriesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getGameCategoriesShortInfo } from 'backend/games';
import { TEditGameSelectedItem } from 'modules/Entertainment/Games/EditGame/editGameState/editGameContext';
import { useTranslation } from 'react-i18next';

interface ICategorySelect {
	setIDCategory: (value: TEditGameSelectedItem) => void;
	setFetchedCategories: (value: IItemForGetShortInfo[]) => void;
}

const CategorySelect: React.FC<ICategorySelect> = ({ setIDCategory, setFetchedCategories }) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetGameCategoriesShort, void>(
		getGameCategoriesShortInfo,
	);
	const { t } = useTranslation('error');

	useEffect(() => {
		if (response) {
			setFetchedCategories(response.data.gameCategories);
		}
	}, [response]);

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCategory') }], [t]);

	return (
		<FormSelect
			testId="CategorySelect"
			name="IDSelectedCategory"
			label="categoryLabel"
			options={response?.data.gameCategories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setIDCategory}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CategorySelect);
